// extracted by mini-css-extract-plugin
export default {"cta":"CTA_cta__IqaT5","text":"CTA_text__4SMMT","btn":"CTA_btn__NKOl+","img":"CTA_img__zCdGl"};